const APIUrl = "https://signal-api.ailtra.app/api/";

export const auth0AudienceId = "https://dev-gu4rza3y0kjyasbc.us.auth0.com/api/v2/";
export const auth0Domain = "dev-gu4rza3y0kjyasbc.us.auth0.com";
export const auth0ClientId = "zB100jKMPObMIDEv1cFVlDdIpL0a6N3V";
export const auth0ClientSecret = "cGEyHPQitbf3WCAeHlo_sJ2SGXJYxT2lUypytjrbgdvH8yLnwUSmnDgoB28ikv3z";

export function apiUrl(endpoint: string): string {
    let url = `${APIUrl}${endpoint}`;
    return url;
}

type Headers = {
    'Content-Type': string;
    Authorization?: string;
    refreshToken?: string;
};

export async function post(url: string, data: any, withToken: boolean = true): Promise<any> {
    const headers: Headers = {
        'Content-Type': 'application/json',
    };

    if (withToken) {
        const accessToken = localStorage.getItem('ailtra_bot_idToken');
        if (accessToken) {
            const token = JSON.parse(accessToken);
            headers.Authorization = `Bearer ${token}`;
        }
    }

    return fetch(apiUrl(url), {
        method: 'POST',
        headers,
        body: JSON.stringify(data),
    }).then((response) => response.json());
}

export async function patch(url: string, data: any, withToken: boolean = true): Promise<any> {
    const headers: Headers = {
        'Content-Type': 'application/json',
    };

    if (withToken) {
        const accessToken = localStorage.getItem('ailtra_bot_idToken');
        if (accessToken) {
            const token = JSON.parse(accessToken);
            headers.Authorization = `Bearer ${token}`;
        }
    }

    return fetch(apiUrl(url), {
        method: 'PATCH',
        headers,
        body: JSON.stringify(data),
    }).then((response) => response.json());
}

export async function put(url: string, data: any, withToken: boolean = true): Promise<any> {
    const headers: Headers = {
        'Content-Type': 'application/json',
    };

    if (withToken) {
        const accessToken = localStorage.getItem('ailtra_bot_idToken');
        if (accessToken) {
            const token = JSON.parse(accessToken);
            headers.Authorization = `Bearer ${token}`;
        }
    }

    return fetch(apiUrl(url), {
        method: 'PUT',
        headers,
        body: JSON.stringify(data),
    }).then((response) => response.json());
}

export async function get(url: string, withToken: boolean = true): Promise<any> {
    const headers: Headers = { 'Content-Type': 'application/json', };

    if (withToken) {
        const accessToken = localStorage.getItem('ailtra_bot_idToken');
        if (accessToken) {
            const token = JSON.parse(accessToken);
            headers.Authorization = `Bearer ${token}`;
        }
    }

    const response = await fetch(apiUrl(url), { headers });

    if (!response.ok) {
        const errorText = await response.text().catch(() => response.statusText);
        throw new Error(errorText || `HTTP ${response.status}`);
    }

    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
        return response.json();
    } else {
        return response.text();
    }
}

// export function handleError(error: any) {
//     // var message = '';
//     // if (error.error !== null && (error.error.error !== null && (error.error.error.message !== undefined || error.error.error.message !== null || error.error.error.message !== '')))
//     //     message = error.error.error.message;
//     // else if (error.error !== null && (error.error.message !== undefined || error.error.message !== null || error.error.message !== ''))
//     //     message = error.error.message;
//     // else
//     //     message = error.message;

//     return { statusCode: error.response.data.statusCode, statusMessage: error.response.data.statusMessage };
// }
